const updateOrderAttribute = (_field,_value) =>{
  const deliveryPickerArea = document.querySelector("#delivery-picker-area");
  const form_data = {
    attributes: {}
  }
  form_data.attributes[_field] = _value;
  fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'dataType': 'json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(form_data)
    })
    .then((data) => {
      console.log(`${_field} updated. ${form_data.attributes[_field]}`)
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      deliveryPickerArea.classList.remove("is-loading");
    });
}

document.addEventListener("DOMContentLoaded", () => {
  const datePickerList = document.querySelectorAll("[data-date_picker]");
  const deliveryPickerArea = document.querySelector("#delivery-picker-area");

  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 3);
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 60);

  let disabledDates = deliveryPickerArea.getAttribute("data-disable_dates"); 
  if(disabledDates.length > 0){
    disabledDates = JSON.parse(disabledDates);
  }else{
    disabledDates = [];
  }

  datePickerList.forEach((datePicker) => {
    if(datePicker.id){
      const datePickerId = datePicker.id;
      const pickerObject = flatpickr(`#${datePickerId}`,{
        dateFormat: "Y-m-d",
        minDate: minDate,
        maxDate: maxDate,
        disable: disabledDates,
        onChange: function(selectedDates, dateStr, instance) {
          const field = datePicker.name,
                value = dateStr;
          updateOrderAttribute(field,value);
          deliveryPickerArea.classList.add("is-loading");
        }
      });

      const clearBtn = document.querySelector(`[data-clear="${datePickerId}"]`);
      if(clearBtn){
        clearBtn.addEventListener("click", () => {
          pickerObject.clear();
        });
      }
    }
  });

  
  const timeSelectList = document.querySelectorAll("[data-time_select]");
  timeSelectList.forEach((timeSelect) => {
    timeSelect.addEventListener("change", (event) => {
      const field = event.target.name,
            value = event.target.value;
      updateOrderAttribute(field,value);
      deliveryPickerArea.classList.add("is-loading");
    });
  });
});